import React, { useState } from 'react';
import { AddModelModal } from './AddModelModal';
import { ModelDetailsModal } from './ModelDetailsModal';
import { ModelErrorsModal } from './ModelErrorsModal';
export const ModelsView = () => {
  const [isAddModelModalOpen, setIsAddModelModalOpen] = useState(false);
  const [selectedModel, setSelectedModel] = useState(null);
  const [isDetailsModalOpen, setIsDetailsModalOpen] = useState(false);
  const [isErrorModalOpen, setIsErrorModalOpen] = useState(false);
  // Sample data for the table
  const models = [{
    id: 1,
    name: 'Historical Average',
    type: 'Time Series Analysis',
    lastUpdate: '2023-05-15 08:30 AM',
    status: 'healthy',
    accuracy: 'High (92%)'
  }, {
    id: 2,
    name: 'Future Trend',
    type: 'Regression',
    lastUpdate: '2023-05-15 09:15 AM',
    status: 'error',
    errorCount: 2,
    accuracy: 'Medium (85%)'
  }, {
    id: 3,
    name: 'Estimated Travelers by Type',
    type: 'Classification',
    lastUpdate: '2023-05-15 10:00 AM',
    status: 'healthy',
    accuracy: 'High (91%)'
  }, {
    id: 4,
    name: 'COMPSET',
    type: 'Competitive Analysis',
    lastUpdate: '2023-05-14 11:45 PM',
    status: 'error',
    errorCount: 1,
    accuracy: 'Medium (87%)'
  }];
  const handleViewClick = model => {
    setSelectedModel(model);
    setIsDetailsModalOpen(true);
  };
  const handleViewErrors = () => {
    setIsDetailsModalOpen(false);
    setIsErrorModalOpen(true);
  };
  const handleBackToModel = () => {
    setIsErrorModalOpen(false);
    setIsDetailsModalOpen(true);
  };
  return <div className="h-full" data-id="element-695">
      <h2 className="text-2xl font-semibold text-gray-800 mb-6" data-id="element-696">
        Models Settings
      </h2>
      <div className="bg-white rounded-lg border border-gray-200 p-6 mb-6" data-id="element-697">
        <div className="flex justify-between items-center mb-4" data-id="element-698">
          <h3 className="text-lg font-medium text-gray-700" data-id="element-699">
            Available Models
          </h3>
          <div className="flex gap-2" data-id="element-700">
            <button className="px-3 py-2 flex items-center gap-2 text-sm font-medium text-gray-700 border border-gray-300 rounded-md hover:bg-gray-50" data-id="element-701">
              <svg xmlns="http://www.w3.org/2000/svg" className="h-5 w-5" viewBox="0 0 20 20" fill="currentColor" data-id="element-702">
                <path fillRule="evenodd" d="M4 2a1 1 0 011 1v2.101a7.002 7.002 0 0111.601 2.566 1 1 0 11-1.885.666A5.002 5.002 0 005.999 7H9a1 1 0 010 2H4a1 1 0 01-1-1V3a1 1 0 011-1zm.008 9.057a1 1 0 011.276.61A5.002 5.002 0 0014.001 13H11a1 1 0 110-2h5a1 1 0 011 1v5a1 1 0 11-2 0v-2.101a7.002 7.002 0 01-11.601-2.566 1 1 0 01.61-1.276z" clipRule="evenodd" data-id="element-703" />
              </svg>
              Refresh All
            </button>
            <button className="px-3 py-2 flex items-center gap-2 text-sm font-medium text-white bg-teal-500 rounded-md hover:bg-teal-600" onClick={() => setIsAddModelModalOpen(true)} data-id="element-704">
              <svg xmlns="http://www.w3.org/2000/svg" className="h-5 w-5" viewBox="0 0 20 20" fill="currentColor" data-id="element-705">
                <path fillRule="evenodd" d="M10 3a1 1 0 011 1v5h5a1 1 0 110 2h-5v5a1 1 0 11-2 0v-5H4a1 1 0 110-2h5V4a1 1 0 011-1z" clipRule="evenodd" data-id="element-706" />
              </svg>
              Add Model
            </button>
          </div>
        </div>
        <div className="overflow-x-auto" data-id="element-707">
          <table className="min-w-full divide-y divide-gray-200" data-id="element-708">
            <thead className="bg-gray-50" data-id="element-709">
              <tr data-id="element-710">
                <th scope="col" className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider" data-id="element-711">
                  Model
                </th>
                <th scope="col" className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider" data-id="element-712">
                  Type
                </th>
                <th scope="col" className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider" data-id="element-713">
                  Last Update
                </th>
                <th scope="col" className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider" data-id="element-714">
                  Status
                </th>
                <th scope="col" className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider" data-id="element-715">
                  Accuracy
                </th>
                <th scope="col" className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider" data-id="element-716">
                  Actions
                </th>
              </tr>
            </thead>
            <tbody className="bg-white divide-y divide-gray-200" data-id="element-717">
              {models.map(model => <tr key={model.id} className="hover:bg-gray-50" data-id="element-718">
                  <td className="px-6 py-4 whitespace-nowrap text-sm font-medium text-gray-900" data-id="element-719">
                    {model.name}
                  </td>
                  <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-500" data-id="element-720">
                    {model.type}
                  </td>
                  <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-500" data-id="element-721">
                    {model.lastUpdate}
                  </td>
                  <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-500" data-id="element-722">
                    {model.status === 'healthy' ? <span className="flex items-center" data-id="element-723">
                        <svg className="h-5 w-5 text-green-500 mr-1.5" fill="currentColor" viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg" data-id="element-724">
                          <path fillRule="evenodd" d="M10 18a8 8 0 100-16 8 8 0 000 16zm3.707-9.293a1 1 0 00-1.414-1.414L9 10.586 7.707 9.293a1 1 0 00-1.414 1.414l2 2a1 1 0 001.414 0l4-4z" clipRule="evenodd" data-id="element-725" />
                        </svg>
                        Healthy
                      </span> : <span className="flex items-center" data-id="element-726">
                        <svg className="h-5 w-5 text-red-500 mr-1.5" fill="currentColor" viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg" data-id="element-727">
                          <path fillRule="evenodd" d="M18 10a8 8 0 11-16 0 8 8 0 0116 0zm-7 4a1 1 0 11-2 0 1 1 0 012 0zm-1-9a1 1 0 00-1 1v4a1 1 0 102 0V6a1 1 0 00-1-1z" clipRule="evenodd" data-id="element-728" />
                        </svg>
                        {model.errorCount}{' '}
                        {model.errorCount === 1 ? 'Error' : 'Errors'}
                      </span>}
                  </td>
                  <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-500" data-id="element-729">
                    {model.accuracy}
                  </td>
                  <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-500" data-id="element-730">
                    <div className="flex items-center gap-2" data-id="element-731">
                      <button className="text-blue-500 hover:text-blue-700 flex items-center" onClick={() => handleViewClick(model)} data-id="element-732">
                        <span data-id="element-733">View</span>
                        <svg xmlns="http://www.w3.org/2000/svg" className="h-4 w-4 ml-1" fill="none" viewBox="0 0 24 24" stroke="currentColor" data-id="element-734">
                          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M10 6H6a2 2 0 00-2 2v10a2 2 0 002 2h10a2 2 0 002-2v-4M14 4h6m0 0v6m0-6L10 14" data-id="element-735" />
                        </svg>
                      </button>
                      <button className="text-gray-400 hover:text-gray-600" data-id="element-736">
                        <svg xmlns="http://www.w3.org/2000/svg" className="h-5 w-5" viewBox="0 0 20 20" fill="currentColor" data-id="element-737">
                          <path d="M10 6a2 2 0 110-4 2 2 0 010 4zM10 12a2 2 0 110-4 2 2 0 010 4zM10 18a2 2 0 110-4 2 2 0 010 4z" data-id="element-738" />
                        </svg>
                      </button>
                    </div>
                  </td>
                </tr>)}
            </tbody>
          </table>
        </div>
      </div>
      {isAddModelModalOpen && <AddModelModal onClose={() => setIsAddModelModalOpen(false)} data-id="element-739" />}
      {isDetailsModalOpen && selectedModel && <ModelDetailsModal model={selectedModel} onClose={() => setIsDetailsModalOpen(false)} onViewErrors={handleViewErrors} data-id="element-740" />}
      {isErrorModalOpen && selectedModel && <ModelErrorsModal model={selectedModel} onClose={() => setIsErrorModalOpen(false)} onBackToModel={handleBackToModel} data-id="element-741" />}
    </div>;
};